import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("zzf_admin_token") || "";
export const setToken = (t) => localStorage.setItem("zzf_admin_token", t);
export const clearToken = () => localStorage.removeItem("zzf_admin_token");

export const api = () =>
    axios.create({ baseURL: API, headers: { Authorization: `Bearer ${getToken()}` } });

export const imgSrc = (u) =>
    !u ? "" : u.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u;

export const uploadImage = async (file) => {
    const fd = new FormData();
    fd.append("file", file);
    const res = await api().post("/admin/upload", fd, {
        headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${getToken()}` },
    });
    return res.data.url;
};

export const fmtErr = (e) => {
    const d = e?.response?.data?.detail;
    if (!d) return "Something went wrong. Please try again.";
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
    return String(d);
};

export const money = (n) =>
    n === null || n === undefined || n === "" ? "" : `₹${Number(n).toLocaleString("en-IN")}`;
